import { GridColDef } from '@mui/x-data-grid-premium';
import { defaultRenderer } from '../ProjectListTable/utils';
import { inputColunm, numberColumn } from '../BulkEditTable/utils';
import { calculateTotal } from '../FinancesByFy/utils';
import { TType } from '../../hooks/useTranslation';

export const returnBudgetColumns = (
  years: [number, number],
  t: TType,
  onChange,
) => {
  const columns = [];
  for (let i = years[0]; i <= years[1]; i++) {
    columns.push(
      ...[
        numberColumn(
          `FY${i}-landCost`,
          `${t(`projects.properties.LandCG01`)}`,
          onChange,
          false,
          100,
          null,
          true,
          true,
          true,
        ),
        numberColumn(
          `FY${i}-propertyInvestment`,
          `${t(`projects.properties.propertyInvestmentCG111`)}`,
          onChange,
          false,
          100,
          null,
          null,
          true,
          true,
        ),
        numberColumn(
          `FY${i}-retailInvestment`,
          `${t(`projects.properties.retailInvestmentCG1214`)}`,
          onChange,
          false,
          100,
          null,
          null,
          true,
        ),
        numberColumn(
          `FY${i}-retailCost`,
          `${t(`projects.properties.retailCostCG1516`)}`,
          onChange,
          false,
          100,
          null,
          null,
          true,
        ),
        numberColumn(
          `FY${i}`,
          `Total in FY`,
          () => {
            /*do nothing*/
          },
          true,
          100,
          (value, row) =>
            calculateTotal({
              landCost: row?.[`FY${i}-landCost`],
              propertyInvestment: row?.[`FY${i}-propertyInvestment`],
              retailInvestment: row?.[`FY${i}-retailInvestment`],
              retailCost: row?.[`FY${i}-retailCost`],
            }),
          'grayBg',
        ),
      ],
    );
  }
  return columns;
};

export const returnColumns: (
  years: [number, number],
  t: TType,
  onChange,
) => GridColDef<any, any, any>[] = (years, t, onChange) => [
  inputColunm(
    'projectName',
    'Project Name',
    onChange,
    false,
    220,
    null,
    null,
    true,
  ),
  {
    field: 'type',
    headerName: 'Financial type',
    valueGetter: () => 'Project Budget',
    minWidth: 220,
    display: 'flex',
    renderCell: defaultRenderer,
  },
  numberColumn(
    `totalFySum`,
    `Total all FY`,
    () => {
      /*do nothing*/
    },
    true,
    100,
    (value, row, c, p) => {
      let sum = 0;
      for (let i = years[0]; i <= years[1]; i++) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        sum += Number(p.current.getCellValue(row?.id, `FY${i}`)) ?? 0;
      }
      return Number(sum)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    'grayBg',
  ),
  ...returnBudgetColumns(years, t, onChange),
];

export const infoGroup = {
  headerName: 'Project Information',
  groupId: 'projectInformation',
  headerClassName: null,
  children: [
    { field: 'projectName' },
    { field: 'type' },
    { field: 'totalFySum' },
  ],
};
